import {
  CountryDoc,
  FilterRequest,
  CountryResponse,
  CountriesResponse,
  CountrieLightResponse,
} from '@/types/entities';
import { ApiService } from './api.service';
import { endpoints } from './endpoints';

/**
 * Service for handling country-related API calls
 */
export class CountriesApiService extends ApiService {
  // Get all countries (reference data)
  getAll = async (): Promise<CountrieLightResponse> => this.get(endpoints.countries.all);

  getFilteredCountries = async (filters: FilterRequest): Promise<CountriesResponse> =>
    this.post(endpoints.countries.filtered, filters);

  deleteCountry = async (id: string): Promise<void> => this.delete(endpoints.countries.delete(id));

  getCountryById = async (id: string): Promise<CountryResponse> =>
    this.get(endpoints.countries.byId(id));

  createCountry = async (data: Partial<CountryDoc>): Promise<CountryDoc> =>
    this.post(endpoints.countries.create, data);

  updateCountry = async (id: string, data: Partial<CountryDoc>): Promise<CountryDoc> =>
    this.patch(endpoints.countries.update(id), data);
}

// Export a singleton instance
export const countriesApiService = new CountriesApiService();

// Named exports for convenience
export const {
  getAll: getCountries,
  getFilteredCountries,
  deleteCountry,
  getCountryById,
  createCountry,
  updateCountry,
} = countriesApiService;
